import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },

  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "首页", icon: "home" }
      }
    ]
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true }
];

// AO管理员后台
export const asyncRouterMap = [
  {
    path: "/admin/user",
    component: Layout,
    redirect: "/admin/user/Goods",
    name: "user",
    meta: { title: "用户管理", icon: "product" },
    children: [
      {
        path: "Goods",
        name: "Goods",
        component: () => import("@/views/goods/Goods"),
        meta: { title: "账户管理", icon: "product-list" }
      },
      {
        path: "Studio",
        name: "Studio",
        component: () => import("@/views/goods/Studio"),
        meta: { title: "工作室" },
        hidden: true
      },
      {
        path: "LoginAccount",
        name: "LoginAccount",
        component: () => import("@/views/goods/LoginAccount"),
        meta: { title: "登录账号" },
        hidden: true
      },
      {
        path: "Server",
        name: "Server",
        component: () => import("@/views/goods/Server"),
        meta: { title: "服务开通", icon: "product-add" }
      },
      {
        path: "PayRecords",
        name: "PayRecords",
        component: () => import("@/views/goods/PayRecords"),
        meta: { title: "购买记录", icon: "product-cate" }
      }
    ]
  },
  {
    path: "/admin/knowledge",
    component: Layout,
    redirect: "/admin/knowledge/Classification",
    name: "knowledge",
    meta: { title: "知识库管理", icon: "order" },
    children: [
      {
        path: "Classification",
        name: "Classification",
        component: () => import("@/views/Knowledge/Classification"),
        meta: { title: "AO知识库分类", icon: "product-list" }
      },
      {
        path: "KnowledgeBase",
        name: "KnowledgeBase",
        component: () => import("@/views/Knowledge/KnowledgeBase"),
        meta: { title: "AO知识库管理", icon: "order-return-reason" }
      },
      {
        path: "previewEdit",
        name: "previewEdit",
        component: () => import("@/views/Knowledge/preview/edit"),
        meta: { title: "AO知识库管理-编辑" },
        hidden: true
      },
      {
        path: "editlmage",
        name: "editlmage",
        component: () => import("@/views/Knowledge/preview/editlmage"),
        meta: { title: "AO知识库管理-编辑照片" },
        hidden: true
      },
      {
        path: "preview",
        name: "preview",
        component: () => import("@/views/Knowledge/preview/preview"),
        meta: { title: "AO知识库管理-预览" },
        hidden: true
      },
      {
        path: "case",
        name: "case",
        component: () => import("@/views/Knowledge/case/case"),
        meta: { title: "AO知识库管理-发布病例" },
        hidden: true
      },
      {
        path: "UploadPhotos",
        name: "UploadPhotos",
        component: () => import("@/views/Knowledge/case/UploadPhotos"),
        meta: { title: "AO知识库管理-发布病例(上传图片)" },
        hidden: true
      },
      {
        path: "UploadVideo",
        name: "UploadVideo",
        component: () => import("@/views/Knowledge/case/UploadVideo"),
        meta: { title: "AO知识库管理-发布病例(上传视频)" },
        hidden: true
      },
      {
        path: "Finish",
        name: "Finish",
        component: () => import("@/views/Knowledge/case/Finish"),
        meta: { title: "AO知识库管理-发布病例(完成)" },
        hidden: true
      },
      {
        path: "Clinic",
        name: "Clinic",
        component: () => import("@/views/Knowledge/Clinic"),
        meta: { title: "诊所病例管理", icon: "order-return" }
      },
      {
        path: "Doctor",
        name: "Doctor",
        component: () => import("@/views/Knowledge/Doctor"),
        meta: { title: "医生病例管理", icon: "sms-flash" }
      }
    ]
  },
  {
    path: "/admin/configure",
    component: Layout,
    redirect: "/admin/configure/Advertisement",
    name: "configure",
    meta: { title: "后台配置", icon: "order-setting" },
    children: [
      {
        path: "Advertisement",
        name: "Advertisement",
        component: () => import("@/views/configure/Advertisement"),
        meta: { title: "广告轮播管理", icon: "sms-flash" }
      },
      {
        path: "addAdvertise",
        name: "addHomeAdvertise",
        component: () => import("@/views/configure/addAdvertisement"),
        meta: { title: "添加轮播" },
        hidden: true
      },
      {
        path: "updateAdvertise",
        name: "updateHomeAdvertise",
        component: () => import("@/views/configure/updateAdvertisement"),
        meta: { title: "编辑轮播" },
        hidden: true
      },
      {
        path: "DynamicInformation",
        name: "DynamicInformation",
        component: () => import("@/views/configure/DynamicInformation"),
        meta: { title: "动态信息管理", icon: "sms-coupon" }
      },
      {
        path: "ServerBag",
        name: "ServerBag",
        component: () => import("@/views/configure/ServerBag"),
        meta: { title: "服务包管理", icon: "product-brand" }
      },
      {
        path: "BasicData",
        name: "BasicData",
        component: () => import("@/views/configure/BasicData"),
        meta: { title: "基础数据", icon: "sms-new" }
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

// 诊所管理员后台
export const asyncRouterMap4Clinic = [
  {
    path: "/clinic",
    component: Layout,
    redirect: "/clinic/SonAccountManagement",
    name: "user",
    meta: { title: "账户管理", icon: "product" },
    children: [
      {
        path: "SonAccountManagement",
        name: "SonAccountManagement",
        component: () => import("@/views/clinicAdmin/SonAccountManagement"),
        meta: { title: "子账户管理", icon: "product-list" }
      },
      {
        path: "Binding",
        name: "Binding",
        component: () => import("@/views/clinicAdmin/Binding"),
        meta: { title: "绑定申请" },
        hidden: true
      },
      {
        path: "ServerPay",
        name: "ServerPay",
        component: () => import("@/views/clinicAdmin/ServerPay"),
        meta: { title: "服务购买", icon: "product-add" }
      },
      {
        path: "Ali",
        name: "Ali",
        component: () => import("@/views/clinicAdmin/Ali"),
        meta: { title: "支付宝", icon: "product-add" },
        hidden: true
      }
    ]
  },
  {
    path: "/clinic/knowledge",
    component: Layout,
    redirect: "/clinic/knowledge/Classification",
    name: "knowledge",
    meta: { title: "病例管理", icon: "order" },
    children: [
      {
        path: "Classification",
        name: "Classification",
        component: () => import("@/views/Knowledge/Classification"),
        meta: { title: "病例分类", icon: "product-list" }
      },
      {
        path: "KnowledgeBase",
        name: "KnowledgeBase",
        component: () => import("@/views/Knowledge/KnowledgeBase"),
        meta: { title: "诊所病例管理", icon: "order-return" }
      },
      {
        path: "previewEdit",
        name: "previewEdit",
        component: () => import("@/views/Knowledge/preview/edit"),
        meta: { title: "AO知识库管理-编辑" },
        hidden: true
      },
      {
        path: "editlmage",
        name: "editlmage",
        component: () => import("@/views/Knowledge/preview/editlmage"),
        meta: { title: "AO知识库管理-编辑照片" },
        hidden: true
      },
      {
        path: "preview",
        name: "preview",
        component: () => import("@/views/Knowledge/preview/preview"),
        meta: { title: "AO知识库管理-预览" },
        hidden: true
      },
      {
        path: "case",
        name: "case",
        component: () => import("@/views/Knowledge/case/case"),
        meta: { title: "AO知识库管理-发布病例" },
        hidden: true
      },
      {
        path: "UploadPhotos",
        name: "UploadPhotos",
        component: () => import("@/views/Knowledge/case/UploadPhotos"),
        meta: { title: "AO知识库管理-发布病例(上传图片)" },
        hidden: true
      },
      {
        path: "UploadVideo",
        name: "UploadVideo",
        component: () => import("@/views/Knowledge/case/UploadVideo"),
        meta: { title: "AO知识库管理-发布病例(上传视频)" },
        hidden: true
      },
      {
        path: "Finish",
        name: "Finish",
        component: () => import("@/views/Knowledge/case/Finish"),
        meta: { title: "AO知识库管理-发布病例(完成)" },
        hidden: true
      },
      {
        path: "Doctor",
        name: "Doctor",
        component: () => import("@/views/Knowledge/Doctor"),
        meta: { title: "医生病例管理", icon: "sms-flash" }
      }
    ]
  },
  {
    path: "/clinic/manage",
    component: Layout,
    redirect: "/clinic/manage/ClinicSuggest",
    name: "clinic",
    meta: { title: "诊所管理", icon: "order-return" },
    children: [
      {
        path: "ClinicSuggest",
        name: "ClinicSuggest",
        component: () => import("@/views/clinicAdmin/ClinicSuggest"),
        meta: { title: "诊所介绍", icon: "sms-flash" }
      },
      {
        path: "updateAdvertise",
        name: "updateHomeAdvertise",
        component: () => import("@/views/configure/updateAdvertisement"),
        meta: { title: "编辑轮播" },
        hidden: true
      },
      {
        path: "addAdvertise",
        name: "addHomeAdvertise",
        component: () => import("@/views/configure/addAdvertisement"),
        meta: { title: "添加轮播" },
        hidden: true
      },
      {
        path: "ExpertSuggest",
        name: "ExpertSuggest",
        component: () => import("@/views/clinicAdmin/ExpertSuggest"),
        meta: { title: "专家介绍", icon: "sms-coupon" }
      },
      {
        path: "PhysicianSuggest",
        name: "PhysicianSuggest",
        component: () => import("@/views/clinicAdmin/PhysicianSuggest"),
        meta: { title: "医师介绍", icon: "product-brand" }
      },
      {
        path: "Edit",
        name: "Edit",
        component: () => import("@/views/clinicAdmin/introduce/Edit"),
        meta: { title: "医师介绍-编辑" },
        hidden: true
      },
      {
        path: "ViewDetails",
        name: "ViewDetails",
        component: () => import("@/views/clinicAdmin/introduce/ViewDetails"),
        meta: { title: "医师介绍-查看详情" },
        hidden: true
      },
      {
        path: "DiagnosedCases",
        name: "DiagnosedCases",
        component: () => import("@/views/clinicAdmin/DiagnosedCases"),
        meta: { title: "初诊病例", icon: "sms-new" }
      },
      {
        path: "caseEdit",
        name: "caseEdit",
        component: () => import("@/views/clinicAdmin/caseEdit"),
        meta: { title: "新增初诊" },
        hidden: true
      },
      {
        path: "NewAdd",
        name: "NewAdd",
        component: () => import("@/views/clinicAdmin/introduce/NewAdd"),
        meta: { title: "新增医师" },
        hidden: true
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

// 工作室管理员后台
export const asyncRouterMap4Studio = [
  {
    path: "/studio",
    component: Layout,
    redirect: "/studio/SonAccountManagement",
    name: "user",
    meta: { title: "账户管理", icon: "product" },
    children: [
      {
        path: "SonAccountManagement",
        name: "SonAccountManagement",
        component: () => import("@/views/clinicAdmin/SonAccountManagement"),
        meta: { title: "子账户管理", icon: "product-list" }
      },
      {
        path: "Binding",
        name: "Binding",
        component: () => import("@/views/clinicAdmin/Binding"),
        meta: { title: "绑定申请" },
        hidden: true
      },
      {
        path: "ServerPay",
        name: "ServerPay",
        component: () => import("@/views/clinicAdmin/ServerPay"),
        meta: { title: "服务购买", icon: "product-add" }
      },
      {
        path: "Ali",
        name: "Ali",
        component: () => import("@/views/clinicAdmin/Ali"),
        meta: { title: "支付宝", icon: "product-add" },
        hidden: true
      }
    ]
  },
  {
    path: "/studio/knowledge",
    component: Layout,
    redirect: "/studio/knowledge/Classification",
    name: "knowledge",
    meta: { title: "病例管理", icon: "order" },
    children: [
      {
        path: "Classification",
        name: "Classification",
        component: () => import("@/views/Knowledge/Classification"),
        meta: { title: "病例分类", icon: "product-list" }
      },
      {
        path: "KnowledgeBase",
        name: "KnowledgeBase",
        component: () => import("@/views/Knowledge/KnowledgeBase"),
        meta: { title: "我的病例管理", icon: "order-return" }
      },
      {
        path: "previewEdit",
        name: "previewEdit",
        component: () => import("@/views/Knowledge/preview/edit"),
        meta: { title: "AO知识库管理-编辑" },
        hidden: true
      },
      {
        path: "editlmage",
        name: "editlmage",
        component: () => import("@/views/Knowledge/preview/editlmage"),
        meta: { title: "AO知识库管理-编辑照片" },
        hidden: true
      },
      {
        path: "preview",
        name: "preview",
        component: () => import("@/views/Knowledge/preview/preview"),
        meta: { title: "AO知识库管理-预览" },
        hidden: true
      },
      {
        path: "case",
        name: "case",
        component: () => import("@/views/Knowledge/case/case"),
        meta: { title: "AO知识库管理-发布病例" },
        hidden: true
      },
      {
        path: "UploadPhotos",
        name: "UploadPhotos",
        component: () => import("@/views/Knowledge/case/UploadPhotos"),
        meta: { title: "AO知识库管理-发布病例(上传图片)" },
        hidden: true
      },
      {
        path: "UploadVideo",
        name: "UploadVideo",
        component: () => import("@/views/Knowledge/case/UploadVideo"),
        meta: { title: "AO知识库管理-发布病例(上传视频)" },
        hidden: true
      },
      {
        path: "Finish",
        name: "Finish",
        component: () => import("@/views/Knowledge/case/Finish"),
        meta: { title: "AO知识库管理-发布病例(完成)" },
        hidden: true
      }
    ]
  },
  {
    path: "/studio/manage",
    component: Layout,
    redirect: "/studio/manage/ClinicSuggest",
    name: "clinic",
    meta: { title: "工作室管理", icon: "order-return" },
    children: [
      {
        path: "ClinicSuggest",
        name: "ClinicSuggest",
        component: () => import("@/views/clinicAdmin/ClinicSuggest"),
        meta: { title: "工作室介绍", icon: "sms-flash" }
      },
      {
        path: "updateAdvertise",
        name: "updateHomeAdvertise",
        component: () => import("@/views/configure/updateAdvertisement"),
        meta: { title: "编辑轮播" },
        hidden: true
      },
      {
        path: "addAdvertise",
        name: "addHomeAdvertise",
        component: () => import("@/views/configure/addAdvertisement"),
        meta: { title: "添加轮播" },
        hidden: true
      },
      {
        path: "ExpertSuggest",
        name: "ExpertSuggest",
        component: () => import("@/views/clinicAdmin/ExpertSuggest"),
        meta: { title: "我的团队", icon: "sms-coupon" }
      },
      {
        path: "NewAdd",
        name: "NewAdd",
        component: () => import("@/views/clinicAdmin/introduce/NewAdd"),
        meta: { title: "新增医师" },
        hidden: true
      },
      {
        path: "Edit",
        name: "Edit",
        component: () => import("@/views/clinicAdmin/introduce/Edit"),
        meta: { title: "医师介绍-编辑" },
        hidden: true
      },
      {
        path: "ViewDetails",
        name: "ViewDetails",
        component: () => import("@/views/clinicAdmin/introduce/ViewDetails"),
        meta: { title: "医师介绍-查看详情" },
        hidden: true
      },
      {
        path: "Myhonor",
        name: "Myhonor",
        component: () => import("@/views/clinicAdmin/Myhonor"),
        meta: { title: "我的荣誉", icon: "product-brand" }
      },
      {
        path: "DiagnosedCases",
        name: "DiagnosedCases",
        component: () => import("@/views/clinicAdmin/DiagnosedCases"),
        meta: { title: "初诊病例", icon: "sms-new" }
      },
      {
        path: "caseEdit",
        name: "caseEdit",
        component: () => import("@/views/clinicAdmin/caseEdit"),
        meta: { title: "新增初诊" },
        hidden: true
      },
      {
        path: "NewAdd",
        name: "NewAdd",
        component: () => import("@/views/clinicAdmin/introduce/NewAdd"),
        meta: { title: "新增医师" },
        hidden: true
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

// 免费医生账号
export const asyncRouterMap4Doctor = [
  {
    path: "/doctor/knowledge",
    component: Layout,
    redirect: "/doctor/knowledge/Classification",
    name: "knowledge",
    meta: { title: "病例管理", icon: "order" },
    children: [
      {
        path: "Classification",
        name: "Classification",
        component: () => import("@/views/Knowledge/Classification"),
        meta: { title: "病例分类", icon: "product-list" }
      },
      {
        path: "KnowledgeBase",
        name: "KnowledgeBase",
        component: () => import("@/views/Knowledge/KnowledgeBase"),
        meta: { title: "我的病例管理", icon: "order-return" }
      },
      {
        path: "previewEdit",
        name: "previewEdit",
        component: () => import("@/views/Knowledge/preview/edit"),
        meta: { title: "AO知识库管理-编辑" },
        hidden: true
      },
      {
        path: "editlmage",
        name: "editlmage",
        component: () => import("@/views/Knowledge/preview/editlmage"),
        meta: { title: "AO知识库管理-编辑照片" },
        hidden: true
      },
      {
        path: "preview",
        name: "preview",
        component: () => import("@/views/Knowledge/preview/preview"),
        meta: { title: "AO知识库管理-预览" },
        hidden: true
      },
      {
        path: "case",
        name: "case",
        component: () => import("@/views/Knowledge/case/case"),
        meta: { title: "AO知识库管理-发布病例" },
        hidden: true
      },
      {
        path: "UploadPhotos",
        name: "UploadPhotos",
        component: () => import("@/views/Knowledge/case/UploadPhotos"),
        meta: { title: "AO知识库管理-发布病例(上传图片)" },
        hidden: true
      },
      {
        path: "UploadVideo",
        name: "UploadVideo",
        component: () => import("@/views/Knowledge/case/UploadVideo"),
        meta: { title: "AO知识库管理-发布病例(上传视频)" },
        hidden: true
      },
      {
        path: "Finish",
        name: "Finish",
        component: () => import("@/views/Knowledge/case/Finish"),
        meta: { title: "AO知识库管理-发布病例(完成)" },
        hidden: true
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

//账号状态为停用时
export const asyncRouterMap4Expire = [
  {
    path: "/expire",
    component: Layout,
    redirect: "/expire/ServerPay",
    name: "user",
    meta: { title: "账户管理", icon: "product" },
    children: [
      {
        path: "ServerPay",
        name: "ServerPay",
        component: () => import("@/views/clinicAdmin/ServerPay"),
        meta: { title: "服务购买", icon: "product-add" }
      },
      {
        path: "Ali",
        name: "Ali",
        component: () => import("@/views/clinicAdmin/Ali"),
        meta: { title: "支付宝", icon: "product-add" },
        hidden: true
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js